//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025, 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

// Must equal the backend constant in workflow/task_agent/activation.py
export const ACTIVATION_MARKER = '[[TASK_ACTIVATED]]';

export function isActivationContent(content?: string | null): boolean {
  return typeof content === 'string' && content.startsWith(ACTIVATION_MARKER);
}

export function stripActivationMarker(content: string): string {
  if (!isActivationContent(content)) return content;
  return content.slice(ACTIVATION_MARKER.length).replace(/^\n+/, '');
}
